import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faKeyboard, faEye, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router";
import { Manager, Supervisor } from "../../../../features/auth/hocs/withAuth";
import useTranslation from "../../../hooks/useTranslation";
import UserMenu from "../UserMenu";

const SupervisorLink = Supervisor(NavLink);
const ManagerLink = Manager(NavLink);

interface Props {
    onToggleSidebar?: () => void;
}

export default function TopBar({ onToggleSidebar }: Props) {
    const { t } = useTranslation();

    return (
        <header className="sticky top-0 z-30 flex h-14 items-center justify-between gap-4 bg-surface px-4">
            <div className="flex items-center gap-3">
                {onToggleSidebar && (
                    <button
                        type="button"
                        onClick={onToggleSidebar}
                        className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-full text-ink hover:bg-surface-3"
                        aria-label="toggle sidebar"
                    >
                        <FontAwesomeIcon icon={faBars} />
                    </button>
                )}
                <NavLink to="/" className="flex items-center gap-2 no-underline!">
                    <span className="flex h-7 w-7 items-center justify-center rounded-lg bg-accent text-sm font-extrabold text-white">
                        A
                    </span>
                    <span className="text-lg font-semibold tracking-tight text-ink">Arnold</span>
                </NavLink>
            </div>
            <div className="flex items-center gap-1">
                <NavLink
                    to="/data-entering"
                    title={t("nav.data_entering")}
                    className={({ isActive }) =>
                        [
                            "flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-surface-3",
                            isActive ? "bg-surface-3 text-accent" : "text-ink",
                        ].join(" ")
                    }
                >
                    <FontAwesomeIcon icon={faKeyboard} />
                </NavLink>
                <ManagerLink
                    to="/management"
                    title={t("attributes.user.role.manager")}
                    className={({ isActive }) =>
                        [
                            "flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-surface-3",
                            isActive ? "bg-surface-3 text-accent" : "text-ink",
                        ].join(" ")
                    }
                >
                    <FontAwesomeIcon icon={faBriefcase} />
                </ManagerLink>
                <SupervisorLink
                    to="/supervising"
                    title={t("attributes.user.role.supervisor")}
                    className={({ isActive }) =>
                        [
                            "flex h-10 w-10 items-center justify-center rounded-full transition-colors hover:bg-surface-3",
                            isActive ? "bg-surface-3 text-accent" : "text-ink",
                        ].join(" ")
                    }
                >
                    <FontAwesomeIcon icon={faEye} />
                </SupervisorLink>
                <div className="ml-2">
                    <UserMenu />
                </div>
            </div>
        </header>
    );
}
